import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, updateCurrentUser } from '../../services/api/UserService';
import AgencyHeader from '../../components/headers/AgencyHeader';
import iconTitle from '../../assets/img/icon-square.svg';
import AccountEditForm from '../../components/AccountEditForm';
import AccountEditConfirmationPopup from '../../components/popups/AccountEditConfirmationPopup';
import '../../styles/AccountCreate.css';

const AccountEdit = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    accountname: '',
    password: '',
    confirmPassword: ''
  });
  
  // ポップアップの状態を管理するステート
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);

  // コンポーネントマウント時にユーザー情報を取得
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setIsLoading(true);
        const userData = await getCurrentUser();
        setFormData({
          username: userData.username || '',
          accountname: userData.accountname || '',
          password: '',
          confirmPassword: ''
        });
      } catch (error) {
        // エラーダイアログ表示はBaseApiServiceで行う
        // エラーコンソール出力は各ApiServiceで行う
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []); // 依存配列を空に設定（マウント時のみ実行）

  const handleSubmit = (e) => {
    e.preventDefault();
    // フォームの検証
    if (formData.password !== formData.confirmPassword) {
      alert('パスワードと再確認が一致しません');
      return;
    }
    
    // 確認ポップアップを表示
    setShowConfirmationPopup(true);
  };

  // ポップアップを閉じる関数
  const closeConfirmationPopup = () => {
    setShowConfirmationPopup(false);
  };

  // 編集を確定する関数
  const confirmEdit = async () => {
    try {
      setIsLoading(true);
      
      // 更新するデータを準備（空のパスワードは送信しない）
      const updateData = {
        username: formData.username,
        accountname: formData.accountname
      };
      
      if (formData.password) {
        updateData.password = formData.password;
      }
      
      // API通信処理
      const response = await updateCurrentUser(updateData);
      
      // 編集成功後の処理
      closeConfirmationPopup();
      navigate(-1);
    } catch (error) {
      // エラーダイアログ表示はBaseApiServiceで行う
      // エラーコンソール出力は各ApiServiceで行う
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="account-create-page">
      <AgencyHeader onMenuToggle={(isOpen) => {
        // メニューの状態が変更された時の処理をここに追加できます
      }} />
      <div className="page-container">
        <div className="content-wrapper">
          <div className="page-header">
            <div className="title-section">
              <div className="icon-square">
                <img src={iconTitle} alt="タイトルアイコン" />
              </div>
              <h1>基本情報</h1>
            </div>
          </div>
          
          {/* AccountEditFormにpropsを渡す */}
          <AccountEditForm 
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleSubmit}
            isLoading={isLoading}
          />
        </div>
      </div>
      
      {/* 確認ポップアップを追加 */}
      <AccountEditConfirmationPopup
        showConfirmationPopup={showConfirmationPopup}
        formData={formData}
        closeConfirmationPopup={closeConfirmationPopup}
        confirmEdit={confirmEdit}
      />
    </div>
  );
};

export default AccountEdit;